import { createSlice } from "@reduxjs/toolkit";

export interface AccessDeniedState {
  open: boolean;
}

const initialState: AccessDeniedState = {
  open: false,
};

const accessDeniedSlice = createSlice({
  name: "accessDenied",
  initialState,
  reducers: {
    openAccessDeniedDialog: (state) => {
      state.open = true;
    },
    closeAccessDeniedDialog: (state) => {
      state.open = false;
    },
  },
});

export const { openAccessDeniedDialog, closeAccessDeniedDialog } = accessDeniedSlice.actions;

export default accessDeniedSlice.reducer;
